module.exports = __webpack_public_path__ + "static/media/mail.2de50e0b.svg";